import axios from 'axios';

const isBrowser = typeof window !== 'undefined' && typeof window.location !== 'undefined';
const sameOrigin = isBrowser ? window.location.origin : 'http://localhost:3001';
// All backend routes are namespaced under /api (avoids collisions with SPA page URLs).
// Production: use REACT_APP_API_URL if set, otherwise same origin (Hostinger Node app).
const apiHost = process.env.REACT_APP_API_URL?.trim()
    ? process.env.REACT_APP_API_URL.trim().replace(/\/$/, '')
    : (process.env.NODE_ENV === 'production' ? sameOrigin : 'http://localhost:3001');
const baseURL = `${apiHost}/api`;

const api = axios.create({
    baseURL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add token if available (though cookie is preferred/httponly)
// But for some setups where token is in localstorage:
api.interceptors.request.use((config) => {
    // If using local storage fallback
    // const token = localStorage.getItem('token');
    // if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            const url = error.config?.url || '';
            // Expired/invalid session (but not a failed login attempt):
            // let AuthContext clear the session and redirect to sign-in.
            if (!url.includes('/auth/login') && typeof window !== 'undefined') {
                window.dispatchEvent(new CustomEvent('auth:unauthorized'));
            }
        }
        return Promise.reject(error);
    }
);

export default api;
